import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from 'src/app/services/i18n.service';

// {{ 'header.settings' | t }} ou {{ 'deals.comments' | t: { count: 3 } }}
// Impur : le texte doit suivre un changement de langue sans que la clé change (lookup en Map, peu coûteux)
@Pipe({
  name: 't',
  pure: false,
  standalone: false
})
export class TranslatePipe implements PipeTransform {

  constructor(private i18n: I18nService) { }

  transform(key: string, params?: { [name: string]: string | number | null | undefined }): string {
    return this.i18n.t(key, params);
  }
}
